__turbopack_context__.v({
  "blok-big-title": "Table-module__jZy7Ma__blok-big-title",
  "blok-subtitle": "Table-module__jZy7Ma__blok-subtitle",
  "blok-title": "Table-module__jZy7Ma__blok-title",
  "table": "Table-module__jZy7Ma__table",
});
